/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Fragment, PureComponent } from "react";
import { shopContext } from "../../contexts/aniplus";
import { withRouter } from "react-router-dom";
import axios from "axios";

//import '../../css/event210621.css'

import "../../css/event210926.css";

import { toast } from "react-toastify"; //토스트(toast)
// import moment from "moment";
// import { isMobile } from "react-device-detect";

class Event202201_pop extends PureComponent {
  state = {};
  componentDidMount = () => {
    this._getData();
  };

  _getData = async () => {
    const result = await this._getDataApi();
    const intReturn = result.data[0].intReturn;
    const list = result.data[0].listData;

    if (intReturn === 0) {
      this.setState({
        list,
      });

      //alert(list[0].title + '/' + list[1].title + '/' + list[0].idx + '/' + list[0].regDate)
    } else {
      toast.error("주문내역이 존재하지 않습니다.");
    }
  };

  _getDataApi = () => {
    const { apiUrl } = this.props;

    return axios.post(apiUrl + "/event_202201_list", {
      params: {},
    });
  };
  _close = () => {
    const { close } = this.props.childProps;
    close();
  };
  _renderItem = () => {
    const { list } = this.state;

    const lst = list.map((item, index) => {
      return (
        <div className="item">
          <div className="thumb">
            <a href="#">
              <img src={item.img} />
            </a>
          </div>
          <div className="info">
            <p className="date">
              <img src="/img/event/event211217/ico_live.png" alt="LIVE" />{" "}
              {item.liveTime} 첫방송
            </p>
            <p className="subject">
              <a href="#">{item.title}</a>
            </p>
          </div>
        </div>
        /*
                <div style={{ color: '#fff'}} key={index}>
                    {item.title}
                </div>
                */
      );
    });

    return lst;
  };
  render() {
    const { list } = this.state;
    return (
      <Fragment>
        <div className="popup">
          <div className="popCont">
            <button type="button" className="pop_close" onClick={this._close}>
              <img src="/img/event/event211217/pop_close.png" />
            </button>
            <ul className="popContainer">
              <li className="orderName">신작카페 주문내역</li>
              <li className="orderNum">
                <dl>
                  <dt>주문 번호</dt>
                  <dd>{list ? list[0].idx : null}</dd>
                </dl>
                <dl>
                  <dt>주문 일자</dt>
                  <dd>{list ? list[0].regDate : null}</dd>
                </dl>
              </li>
              <li className="orderList">
                <dl>
                  <dt>주문 작품</dt>
                  <dd>{list ? this._renderItem() : null}</dd>
                </dl>
              </li>
            </ul>
            <img src="/img/event/event211217/pop_bg.png" />
          </div>
        </div>

        {/*
                <div>
                    <div onClick={this._close}>닫기</div>
                    { list ? this._renderItem() : null }
                </div>
                */}
      </Fragment>
    );
  }
}

export default shopContext(withRouter(Event202201_pop));
